import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { StatisticService } from '../../../shared/services/statistic.service';
import * as moment from 'moment';
import { InfoPopupComponent } from '../info-popup/info-popup.component';
import { UserService } from '../../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-ranking',
  styleUrls: ['ranking.component.scss'],
  templateUrl: 'ranking.component.html',
})
export class RankingComponent implements AfterViewInit {
  displayedColumns = ['position', 'name', 'punkte'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  date: any;

  aliasForm = new FormGroup({
    alias: new FormControl('', [Validators.maxLength(30)]),
  });

  @ViewChild(InfoPopupComponent) aliasPopup: InfoPopupComponent;

  constructor(private stats: StatisticService, private userService: UserService) {
    this.date = moment();
    this.loadLeaderboard();
  }

  ngAfterViewInit() {
    // scroll to current user
    // setTimeout(() => {
    //   document.querySelector('mat-table .selected').scrollTop(false);
    // }, 1000);

    this.userService.currentUser.subscribe((user) => {
      if (!user) {
        return;
      }

      const alias = user.alias;

      if (!alias) {
        this.aliasPopup.show();
      }
    });
  }

  loadLeaderboard(month?: number, year?: number) {
    this.stats.getCompanyLeaderboard(month, year).then((data) => {
      // order from highest to lowest points
      data.sort((a, b) => {
        return b.points - a.points;
      });

      for (let index = 0; index < data.length; index++) {
        data[index].position = index + 1;
      }

      this.dataSource = new MatTableDataSource(data);
    });
  }

  nextMonth() {
    this.date.add(1, 'M');
    this.loadLeaderboard(this.date.month() + 1, this.date.year());
  }

  prevMonth() {
    this.date.subtract(1, 'M');
    this.loadLeaderboard(this.date.month() + 1, this.date.year());
  }

  saveAlias(anonym?: boolean) {
    if (!anonym && !this.aliasForm.valid) {
      return;
    }

    const alias = anonym ? 'anonym' : this.aliasForm.value.alias ? this.aliasForm.value.alias : 'anonym';
    this.userService
      .updateUser({
        alias: alias,
      })
      .then(() => this.userService.getThisUser());

    this.dataSource.data.find((item) => item.isRequester === true).alias = alias;
    this.aliasPopup.close();
  }
}

export interface Element {
  alias: string;
  position: number;
  points: number;
  isRequester: boolean;
}

const ELEMENT_DATA: Element[] = [
  { position: 0, alias: '...', points: 0, isRequester: false },
  { position: 1, alias: '...', points: 0, isRequester: false },
  { position: 2, alias: '...', points: 0, isRequester: false },
  { position: 3, alias: '...', points: 0, isRequester: false },
  { position: 4, alias: '...', points: 0, isRequester: false },
  { position: 5, alias: '...', points: 0, isRequester: false },
];



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/ranking/ranking.component.ts